import axios from "axios";

// export const base_url = "http://localhost:30032/api";
export const base_url = "https://makkytradeapi.muekarator.com/api";

export const apiClient = axios.create({
  baseURL: base_url,
  headers: {
    "Content-Type": "application/json",
  },
});

// Attach token to every request if available
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("user_token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Request OTP endpoint
export const receiveOTP = async (email) => {
  try {
    const payload = { email };
    const response = await apiClient.post("/mtrade/auth/send-otp", payload);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Send login otp
export const sendLoginOTP = async (email) => {
  try {
    const payload = { email };
    const response = await apiClient.post("/mtrade/auth/send-login-otp", payload);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

// Verify OTP endpoint
export const verifyOTP = async (email, otp) => {
  try {
    const response = await apiClient.post("/mtrade/auth/verify-otp", {
      email,
      otp,
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createUser = async (email, role, referralCode) => {
  try {
    const payload = { email, role, referralCode };

    const response = await apiClient.post(
      "/mtrade/auth/createuser",
      payload
    );
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const loginWithOTP = async (email, otp) => {
  try {
    const payload = { email, otp };
    const response = await apiClient.post("/mtrade/auth/login", payload);
    return response.data;
  } catch (error) {
    console.log("Response data:", error);
    throw error;
  }
};

export const getUser = async () => {
  try{
  const res = await apiClient.get("/mtrade/auth/me");
  return res.data;
 } catch (error) {
    console.error("Error fetching profile: ", error.response?.data || error.message);
    throw error;
  }
};

export const updateProfile = async (formData) => {
  try {
    const res = await apiClient.patch(`/mtrade/auth/update-profile`, formData, {
      headers: {
        // Essential for file uploads via FormData
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Profile update API error:", error.response?.data || error.message);
    throw error;
  }
};

export const updateKYCProfile = async (formData) => {
  try {
    const res = await apiClient.patch(`/mtrade/user/kyc-profile`, formData, {
      headers: {
        // Essential for file uploads via FormData
        "Content-Type": "multipart/form-data",
      },
    });
    return res.data;
  } catch (error) {
    console.error("Profile and KYC update API error:", error.response?.data || error.message);
    throw error;
  }
};

// Get user wallet
export const getUserWallet = async () => {
  try {
     const res = await apiClient.get("/mtrade/get-wallet");
     return res.data;
  } catch (error) {
    console.log("Failed to fetch orders:", error.response?.data || error.message);
    throw error;
  }
};

export const verifyPaymentApi = async (reference) => {
  try {
    const res = await apiClient.get(`/mtrade/payment/verify?reference=${reference}`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch order:", error.response?.data || error.message);
    throw error;
  }
};

export const fetchWalletBalance = async () => {
  try {
    const res = await apiClient.get("/mtrade/get-wallet");
    return res.data;
  } catch (error) {
    console.log(
      "Failed to fetch wallet:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const submitSellProof = async (payload) => {
  try {
    const res = await apiClient.post("/mtrade/trade/proof", payload);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to submit trade proof:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const initiateBuy = async (assetSymbol, nairaAmount) => {
  try {
    const payload = { assetSymbol, nairaAmount }
    const res = await apiClient.post("/mtrade/buy/initiate", payload);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to create buy:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const verifyBuyPaymentApi = async (reference) => {
  try {
    const res = await apiClient.get(`/mtrade/buy/verify/${reference}`);
    return res.data;
  } catch (error) {
    console.log("Failed to verify buy payment:", error.response?.data || error.message);
    throw error;
  }
};

export const initiateSell = async (payload) => {
  try {

    const res = await apiClient.post("/mtrade/sell/initiate", payload);
    return res.data;
  } catch (error) {
    console.log(
      "Failed to create sell:",
      error.response?.data || error.message
    );
    throw error;
  }
};

export const verifySellPaymentApi = async (reference) => {
  try {
    const res = await apiClient.get(`/mtrade/sell/verify/${reference}`);
    return res.data;
  } catch (error) {
    console.log("Failed to verify sell payment:", error.response?.data || error.message);
    throw error;
  }
};

export const getTransactionHistory = async () => {
  try {
    const res = await apiClient.get(`/mtrade/transactions/my-transactions`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch transaction history:", error.response?.data || error.message);
    throw error;
  }
};

export const getBanks = async () => {
  try {
    const res = await apiClient.get(`/mtrade/get-banks`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch banks:", error.response?.data || error.message);
    throw error;
  }
};

export const verifyAccount = async (accountNumber, bankCode) => {
  try {
    const res = await apiClient.post(`/mtrade/verify-account`, {accountNumber, bankCode});
    return res.data;
  } catch (error) {
    console.log("Failed to fetch banks:", error.response?.data || error.message);
    throw error;
  }
};

export const withdrawCryptoAPI = async (payload) => {
  try {
    const res = await apiClient.post(`/mtrade/withdraw`, payload);
    return res.data;
  } catch (error) {
    console.log("Failed withdraw crypto:", error.response?.data || error.message);
    throw error;
  }
};

export const getAssets = async () => {
  try {
    const res = await apiClient.get(`/mtrade/assets/live-rates`);
    return res.data;
  } catch (error) {
    console.log("Failed to fetch assets:", error.response?.data || error.message);
    throw error;
  }
};

export const submitEnquiry = async (userId, category, description) => {
  try {
    const res = await apiClient.post(`/mtrade/support/enquiry`, {userId, category, description});
    return res.data;
  } catch (error) {
    console.log("Failed to submit enquiry:", error.response?.data || error.message);
    throw error;
  }
};

export const getUserTickets = async () => {
  try{
    const res = await apiClient.get(`/mtrade/support/tickets/user`);
    return res.data
  } catch (error) {
    console.log("Failed to get tickets:", error.response?.data || error.message);
    throw error;
  }
};



// ════════════════════════════════════════════════════════════
// AIRTIME
// ════════════════════════════════════════════════════════════

export const buyAirtime = async (network, phone, amount, userPhone) => {
  try{
    const payload = {network, phone, amount, userPhone}
    const res = await apiClient.post(`/mtrade/bills/airtime`, payload);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}

// ════════════════════════════════════════════════════════════
// DATA
// ════════════════════════════════════════════════════════════

export const getDataPlans = async(network) => {
  try{
    const res = await apiClient.get(`/mtrade/bills/data-plans?network=${network}`);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}

export const buyData = async (network, phone, variationCode, amount, userPhone) => {
  try{
    const payload = {network, phone, variationCode, amount, userPhone}
    const res = await apiClient.post(`/mtrade/bills/data`, payload);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}

// ════════════════════════════════════════════════════════════
// ELECTRICITY
// ════════════════════════════════════════════════════════════

export const verifyMeter = async(disco, meterNumber, meterType) =>{
  try{
    const payload = {disco, meterNumber, meterType}
    const res = await apiClient.post(`/mtrade/bills/electricity/verify-disco`, payload);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}


export const buyElectricity = async (disco, meterNumber, meterType, amount, phone) => {
  try{
    const payload = {disco, meterNumber, meterType, amount, phone}
    const res = await apiClient.post(`/mtrade/bills/electricity/buy`, payload);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}

// ════════════════════════════════════════════════════════════
// CABLE TV
// ════════════════════════════════════════════════════════════

export const getTVPlans = async(provider) => {
  try{
    const res = await apiClient.get(`/mtrade/bills/tv/plans?provider=${provider}`);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}

export const verifySmartcard = async(provider, smartcardNo) => {
  try{
    const res = await apiClient.post(`/mtrade/bills/tv/verify-decoder`, {provider, smartcardNo});
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}


export const subscribeTv = async (provider, smartcardNo, variationCode, amount, phone) =>{
  try{
    const payload = {provider, smartcardNo, variationCode, amount, phone}
    const res = await apiClient.post(`/mtrade/bills/tv/subscribe`, payload);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}

// ════════════════════════════════════════════════════════════
// REQUERY
// ════════════════════════════════════════════════════════════

export const requeryTransaction = async (requestId) =>{
   try{
    const res = await apiClient.post(`/mtrade/bills/requery`, { requestId });
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}

// ── API calls ─────────────────────────────────────────────────
export const initializeDeposit = async(amount) => {
  try{
    const res = await apiClient.post("/mtrade/deposit/initialize", { amount });
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}


export const verifyDeposit = async (reference) =>{
  try{
    const res = await apiClient.get(`/api/deposit/verify?reference=${reference}`);
    return res.data
  } catch (error) {
    console.log("Error :", error.response?.data || error.message);
    throw error;
  }
}
  
